import { BaseDto } from "src/dtos/common/baseDto";

export interface MessageDto extends BaseDto {
    messageType: string;
    messageSrc: string;
    messageCd: string;
    messageNm: string;
    remark: string;
    inserted: boolean;
    isModified: boolean;
}

export const defaultMessageDto: MessageDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    messageType: "",
    messageSrc: "",
    messageCd: "",
    messageNm: "",
    remark: "",
    inserted: false,
    isModified: false,
};
